import clsx from 'clsx';
import { ActionButton } from './ActionButton';

export const GroupButton = ({
                              buttons,
                              selected = null,
                              size = 'md',
                              className,
                            }) => {
  return (
    <div className={clsx('inline-flex', className)}>
      {buttons.map((button, index) => {
        const isFirst = index === 0;
        const isLast = index === buttons.length - 1;

        return (
          <ActionButton
            key={button.key ?? index}
            {...button}
            size={button.size ?? size}
            selected={selected === index}
            className={clsx(
              'rounded-none',
              isFirst && 'rounded-l-md',
              isLast && 'rounded-r-md',
              index > 0 && '-ml-px',
              button.className
            )}
          />
        );
      })}
    </div>
  );
};